import { useContext } from 'react'

import {
  OneOnOnesContext,
  type OneOnOnesContextValue,
} from 'modules/one_on_ones/lib/context/OneOnOnesContext'

export const useOneOnOnesContext = (): OneOnOnesContextValue => {
  return useContext(OneOnOnesContext)
}
